"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Super/SuperEditOrganizationScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _log = require('shared/log');

var _features = require('shared/enum/features'); var _features2 = _interopRequireDefault(_features);
var _store = require('web/store');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Tt = require('web/screens/Super/Tt'); var _Tt2 = _interopRequireDefault(_Tt);





const describeAccountStep = (r) => {
  if (r.Skipped) return `Account step skipped: ${r.Skipped}`
  const settings = r.SettingsCopiedBack
    ? 'account settings copied back to the organizations.'
    : r.SettingsCreated
      ? 'account settings created from the strictest organization settings.'
      : 'no settings copied back.'
  return `Account step ran on ${r.Orgs} organizations: ${r.OwnersMade} Owners made, `
    + `${r.MembershipsAdded} memberships added, ${r.KeysMoved} API keys moved, `
    + `${r.MembershipsRemoved} memberships removed, ${settings}`
}

// What gets stricter for one org (D-117).
const describeTightening = (t) => [
  t.MFARequired && 'SMS verification at login turns on',
  t.HidePatientPhones && 'patient phone numbers are hidden from non-admins',
  t.QuickLoginPinOff && 'the quick-login PIN turns off',
].filter(Boolean).join('; ')

const onOff = (v, on, off) => v ? on : off

// Before ACCOUNTS goes on: the settings the account will use for every org,
// and which orgs that makes stricter (D-117).
const SettingsPreview = ({ preview, hasFailed }) => {
  if (hasFailed) return _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}, "Couldn't work out which settings would change. Saving still runs the enable step."            )
  if (!preview) return _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}, "Checking which organizations' settings would change…"     )
  if (preview.Skipped) return null
  const s = preview.Settings
  return (
    _react2.default.createElement('div', { className: "superuser--accounts-preview", role: "region", 'aria-label': "Settings after turning on"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}, "The account's settings are created from the strictest of its organizations' and apply to every one: SMS verification "

          , onOff(s.MFARequired, 'required', 'not required'), ", quick-login PIN "
          , onOff(s.QuickLoginPinAllowed, 'allowed', 'off'), ", patient phone numbers "
           , onOff(s.HidePatientPhones, 'hidden from non-admins', 'shown'), "."
      )
      ,  preview.Tightened.length === 0
        ? _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}, "No organization's settings get stricter."    )
        : (
          _react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}, "These organizations' settings get stricter:"    )
            , _react2.default.createElement('ul', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
              ,  preview.Tightened.map(t => _react2.default.createElement('li', { key: t.OrgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}, _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 57}},  t.Name ), ": " ,  describeTightening(t) )) 
            )
          )
          )
    )
  )
}

// What saving a change to the ACCOUNTS bit does (D-41, D-59, E-48).
const ACCOUNTS_CHANGE = {
  on: {
    title: 'Turn on Accounts?',
    desc: 'If this is its account\'s default organization, the enable step runs on save: admins become Owners '
      + '(on an account linking several organizations, only the default organization\'s admins), Owners and IT '
      + 'join every organization on the account and see its patients, and API keys move to the account.',
    label: 'Turn on Accounts',
  },
  off: {
    title: 'Turn off Accounts?',
    desc: 'If this is its account\'s default organization, the disable step runs on save: it reverses what '
      + 'enabling did, removes the automatic memberships, copies account settings that were set up back to '
      + 'each organization, and keeps every API key working.',
    label: 'Turn off Accounts',
  },
}



const SuperEditOrganizationScreen = ({ match }) => {
  const [deleteModalOpen, setDeleteModalOpen] = _react.useState.call(void 0, false)
  // Unset until the org loads.
  const [orgKey, setOrgKey] = _react.useState(undefined)
  const [name, setName] = _react.useState(undefined)
  const [verified, setVerified] = _react.useState(undefined)
  const [enabledFeatures, setEnabledFeatures] = _react.useState([])
  const [features, setFeatures] = _react.useState([])
  const [savedAccounts, setSavedAccounts] = _react.useState.call(void 0, false)
  const [isAccountsConfirmOpen, setIsAccountsConfirmOpen] = _react.useState.call(void 0, false)
  const [accountStep, setAccountStep] = _react.useState(null)
  const [preview, setPreview] = _react.useState(null)
  const [hasPreviewFailed, setHasPreviewFailed] = _react.useState.call(void 0, false)

  // Loads once, on mount, like componentDidMount.
  _react.useEffect.call(void 0, () => {
    Promise.all([
      _client2.default.send('SuperOrgProfile', { OrgKey: match.params.orgKey }),
      _client2.default.send('SuperListFeatures', {}),
    ]).then((results) => {
      const org = results[0].Org

      setOrgKey(org.OrgKey)
      setName(org.Name)
      setVerified(org.Verified)
      setEnabledFeatures(org.EnabledFeatures)
      setSavedAccounts(org.EnabledFeatures.includes(_features2.default.ACCOUNTS))
      setFeatures(results[1])
    }).catch(_log.log.error)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const updateName = (evt) => setName(evt.target.value)
  const updateVerified = (evt) => setVerified(evt.target.checked)
  const showDeleteModal = () => setDeleteModalOpen(true)
  const hideDeleteModal = () => setDeleteModalOpen(false)

  const handleDelete = () => {
    _client2.default.send('SUPER_RemoveOrg', { OrgKey: match.params.orgKey })
      .then(() => {
        _store.history.replace(`/super/orgs`)
      }).catch(err => {
        _log.log.error(err)
        hideDeleteModal()
      })
  }

  const featureChanged = (evt) => {
    if (evt.target.checked) {
      if (enabledFeatures.indexOf(evt.target.id) === -1) {
        setEnabledFeatures([...enabledFeatures, evt.target.id])
      }
    } else {
      const index = enabledFeatures.indexOf(evt.target.id)
      if (index > -1) {
        // clone features (cause react) array and remove item if it exists
        const nextEnabledFeatures = enabledFeatures.slice(0)
        nextEnabledFeatures.splice(index, 1)
        setEnabledFeatures(nextEnabledFeatures)
      }
    }
  }

  // SuperUpdateOrgProfile trims the name and allows at most 100 characters.
  const trimmedName = (_nullishCoalesce(name, () => ( ''))).trim()
  const nameError = trimmedName === ''
    ? 'Name is required'
    : trimmedName.length > 100 ? 'Name must be at most 100 characters' : null

  const accountsOn = enabledFeatures.includes(_features2.default.ACCOUNTS)
  const accountsChange = ACCOUNTS_CHANGE[accountsOn ? 'on' : 'off']

  const save = () => {
    setIsAccountsConfirmOpen(false)
    _client2.default.send('SuperUpdateOrgProfile', {
      // SAFETY: the form, and so this button, only renders once the org has loaded.
      OrgKey: orgKey ,
      // SAFETY: as above.
      Name: name ,
      // SAFETY: as above.
      Verified: verified ,
      EnabledFeatures: enabledFeatures,
    }).then(r => {
      // Stays on the form to show what turning ACCOUNTS on or off changed.
      setSavedAccounts(accountsOn)
      if (_optionalChain([r, 'optionalAccess', _ => _.AccountStep])) setAccountStep(r.AccountStep)
      else _store.history.replace(`/super/orgs/${orgKey}`)
    }).catch(_log.log.error)
  }

  // A change to ACCOUNTS runs the account step, so it is confirmed first.
  const submit = (evt) => {
    evt.preventDefault()
    if (nameError) return
    if (accountsOn === savedAccounts) {
      save()
      return
    }
    setIsAccountsConfirmOpen(true)
    if (accountsOn) {
      // Shown in the dialog before staff confirm (D-117).
      setPreview(null)
      setHasPreviewFailed(false)
      _client2.default.send('SuperPreviewAccountEnable', { OrgKey: orgKey  })
        .then(r => setPreview(r.Preview))
        .catch(e => {
          _log.log.error(e)
          setHasPreviewFailed(true)
        })
    }
  }

  // The form renders once the org has loaded, whatever the Name field holds.
  if (orgKey !== undefined) {
    const featureRows = features.map((feature) => {
      const enabled = enabledFeatures.some((enabledFeature) => enabledFeature === feature)
      return (
        _react2.default.createElement('div', { key: feature, __self: this, __source: {fileName: _jsxFileName, lineNumber: 201}}
          , _react2.default.createElement('label', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 202}}
            , _react2.default.createElement('input', { id: feature, type: "checkbox", checked: enabled, onChange: featureChanged, __self: this, __source: {fileName: _jsxFileName, lineNumber: 203}} ), " " , feature
          )
        )
      )
    })

    const deleteModal = (
      _react2.default.createElement(_Modal2.default, {
        isOpen: deleteModalOpen,
        onClose: hideDeleteModal,
        title: "Delete Organization" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}}

        , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 215}}, "Are you sure you want to mark the organization \""
                   , name, "\" as deleted?"  , ' '
        )
        , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 218}}, "This will remove all members from this organization, and delete any patients associated with this organization."

        )
        , _react2.default.createElement(_Modal.ModalControls, {
          secondaryBtnLabel: "Cancel",
          onSecondaryBtnClick: hideDeleteModal,
          primaryBtnTheme: "danger",
          primaryBtnLabel: "Delete",
          onPrimaryBtnClick: handleDelete, __self: this, __source: {fileName: _jsxFileName, lineNumber: 221}}
        )
      )
    )

    const accountsConfirmModal = (
      _react2.default.createElement(_Modal2.default, {
        isOpen: isAccountsConfirmOpen,
        onClose: () => setIsAccountsConfirmOpen(false),
        title: accountsChange.title, __self: this, __source: {fileName: _jsxFileName, lineNumber: 232}}

        , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 237}}, accountsChange.desc)
        ,  accountsOn && _react2.default.createElement(SettingsPreview, { preview: preview, hasFailed: hasPreviewFailed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 238}} ) 
        , _react2.default.createElement(_Modal.ModalControls, {
          secondaryBtnLabel: "Cancel",
          onSecondaryBtnClick: () => setIsAccountsConfirmOpen(false),
          primaryBtnLabel: accountsChange.label,
          onPrimaryBtnClick: save, __self: this, __source: {fileName: _jsxFileName, lineNumber: 239}}
        )
      )
    )

    return (
      _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 249}}
        , deleteModal
        , accountsConfirmModal
        , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 252}}, "Properties")
        , _react2.default.createElement('dl', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 253}}
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 254}}, "OrgKey")
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 255}}, _react2.default.createElement(_Tt2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 255}}, orgKey))
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 256}}, "Name")
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}
            , _react2.default.createElement('input', {
              id: "name",
              type: "text",
              value: _nullishCoalesce(name, () => ( '')),
              onChange: updateName,
              style: { width: '300px' },
              'aria-invalid': nameError !== null,
              'aria-describedby': nameError ? 'name-error' : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 258}}
            )
            ,  nameError ? _react2.default.createElement('div', { id: "name-error", role: "alert", style: { color: 'red' }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 267}}, nameError) : null 
          )
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 269}}, "Verified")
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 270}}, _react2.default.createElement('input', { id: "verified", type: "checkbox", checked: verified, onChange: updateVerified, __self: this, __source: {fileName: _jsxFileName, lineNumber: 270}} ))
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 271}}, "Features")
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 272}}
            , featureRows
            , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 274}}, "ACCOUNTS counts only on the account's default organization; on any other organization it does nothing."              )
          )
        )
        ,  accountStep && _react2.default.createElement('p', { role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 277}}, describeAccountStep(accountStep)) 
        , _react2.default.createElement('a', { className: "blmh-button secondary" , href: "/#/super/orgs/" + orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 278}}, "Cancel"), " "
        , _react2.default.createElement('button', { className: "blmh-button", onClick: submit, disabled: nameError !== null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 279}}, "Update"), " "
        , _react2.default.createElement('button', { className: "blmh-button red" , onClick: showDeleteModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 280}}, "Delete")
      )
    )
  } else {
    return null
  }
}

exports. default = SuperEditOrganizationScreen
